module.exports = __webpack_public_path__ + "img/help-content-6.9c7528db.png";